import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/WABILL_DOC_SCAN`;

export const ROUTES = {
  ROOT: '/waybilldoc/scan',
};

export const FORM_NAME = 'SCAN_WAYBILL_DOC';

export const LOAD_ITEM_TYPES = {
  box: 'BOX',
  pallet: 'PALLET',
};
